import React, { useState, useEffect } from "react";
import { FaBookOpen } from "react-icons/fa";
// import "../../../../src/assets/css/screens/customer/about us/About.css"; // CSS path adjust karein

const Storysection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Animation trigger
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="about-story-section">
      <div className="about-story-container">
        <div className="about-story-grid">
          {/* Story Content */}
          <div className={`about-story-content ${isVisible ? 'about-slide-left' : ''}`}>
            <div className="about-section-badge">
              <span className="about-badge-text"><FaBookOpen/>  OUR STORY</span>
            </div>
            <h2 className="about-section-title">
              Building Trust, One Service at a Time
            </h2>
            <p className="about-story-text">
              Founded in 2020, WorkHub was born from a simple idea: make quality home services accessible to everyone. 
              We noticed the struggle people faced finding reliable professionals for their homes - the endless searching, 
              uncertainty about quality, and lack of accountability.
            </p>
            <p className="about-story-text">
              Today, we've grown into USA's leading home service platform, serving thousands of customers daily.
            </p>
            <div className="about-story-features">
              <div className="about-story-feature">
                <span className="about-feature-check">✓</span>
                <span>Verified Professionals</span>
              </div>
              <div className="about-story-feature">
                <span className="about-feature-check">✓</span>
                <span>Quality Guarantee</span>
              </div>
              <div className="about-story-feature">
                <span className="about-feature-check">✓</span>
                <span>24/7 Support</span>
              </div>
            </div>
          </div>

          {/* Story Image */}
          <div className={`about-story-image ${isVisible ? 'about-slide-right' : ''}`}>
            <img
              src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&h=600&fit=crop"
              alt="Our Team"
              className="about-story-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Storysection;